// src/components/pages/integration/IntegrationsContent.tsx
import React from "react";
import { Loading } from "../../ui/Loading";
import { BLink } from "../../ui/BLink";
import { IntegrationItem } from "../../../models/integrations.model";

interface ContentProps {
	isFirstVisit: boolean;
	categories: any[];
	category: string;
	setCategory: (cat: string) => void;
	activeSection: string;
	setActiveSection: (s: string) => void;
	loading: boolean;
	items: IntegrationItem[];
}

export const IntegrationContent: React.FC<ContentProps> = ({
	isFirstVisit,
	categories,
	category,
	setCategory,
	activeSection,
	setActiveSection,
	loading,
	items,
}) => {
	if (!isFirstVisit) return null;

	return (
		<div className="integration-fade-in">
			<div className="integrations-menu">
				<h2>INTEGRATIONS</h2>
				<ul>
					{categories.map((item) => (
						<li key={item.id}>
							<button
								onClick={() => setCategory(item.attributes.name)}
								className={category === item.attributes.name ? "head-li-selected" : ""}
							>
								{item.attributes.name}
							</button>
						</li>
					))}
				</ul>
			</div>

			<div className="cards-container">
				{loading ? (
					<Loading />
				) : (
					<div className="cards-viewport">
						<div className="cards-grid">
							{items.map((intg) => (
								<BLink
									to={intg.attributes.url}
									activateLink={intg.attributes.featured}
									key={intg.id}
								>
									<div className="grid-container">
										{intg.attributes.featured && intg.attributes.imageUrl && (
											<img
												src={intg.attributes.imageUrl}
												alt="logo"
												width={30}
												height={30}
											/>
										)}
										<div className="card-content">
											<h3>{intg.attributes.name}</h3>
										</div>
									</div>
								</BLink>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default IntegrationContent;
